import { Overlay } from 'ol';

export default {
  methods: {
    removeOverlays({ id }) {
      const mapOverlays = this.map.getOverlays();
      [...mapOverlays.getArray()].forEach(overlay => {
        if (overlay.getId().startsWith(id)) this.map.removeOverlay(overlay);
      });
    },
    setMapOverlayProperty(id, property, value) {
      const overlay = this.map.getOverlayById(id);
      if (!overlay) return;
      switch (property) {
        case 'position':
          return overlay.setPosition(value);
        default:
          throw new Error(`Property ${property} not recognized`);
      }
    },
    createMapOverlay({ id, overlayProps = {}, body, selector }) {
      let overlay = this.map.getOverlayById(id);
      if (!overlay) {
        let overlayDiv;
        if (selector) overlayDiv = selector;
        else {
          overlayDiv = document.createElement('div');
          overlayDiv.id = id;
          document.body.appendChild(overlayDiv);
        }
        const overlayOl = new Overlay({
          id: id,
          element: overlayDiv,
          ...overlayProps,
        });
        this.map.addOverlay(overlayOl);
      }
      overlay = this.map.getOverlayById(id);
      overlay.setPosition(overlayProps.position);
      const overlayDiv = document.querySelector(`#${id}`);
      if (!selector && body) overlayDiv.innerHTML = body;
      return overlay;
    },
  },
  mounted() {
    this.$root.$off('removeOverlays');
    this.$root.$on('removeOverlays', this.removeOverlays);

    this.$root.$off('createMapOverlay');
    this.$root.$on('createMapOverlay', this.createMapOverlay);

    this.$root.$off('setMapOverlayProperty');
    this.$root.$on('setMapOverlayProperty', this.setMapOverlayProperty);
  },
};
